import { render } from "./OfficeAdminAudit.vue?vue&type=template&id=08197bb1"
import script from "./OfficeAdminAudit.vue?vue&type=script&lang=js"
export * from "./OfficeAdminAudit.vue?vue&type=script&lang=js"

import "./OfficeAdminAudit.vue?vue&type=style&index=0&id=08197bb1&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__